<!-- @veltra/icons generated sha256:893ce8b761967275 gen:8 source:src/svg/normal/backtop.svg -->
<script setup lang="ts">
defineOptions({ name: 'Backtop' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M2.505 2.999h10.988A.51.51 0 0 0 14 2.495.507.507 0 0 0 13.493 2H2.505a.51.51 0 0 0-.506.504c0 .268.23.496.506.496m1.223 6.885 3.759-3.689v8.148c0 .28.21.5.49.5h.011c.28 0 .51-.221.51-.5V6.19l3.836 3.742c.195.19.501.18.695-.01a.495.495 0 0 0 .003-.706L8.335 4.635a.5.5 0 0 0-.7.013L3.033 9.167a.51.51 0 0 0-.002.724.503.503 0 0 0 .698-.007"
    />
  </svg>
</template>
